import { Filter } from '@/interfaces/filter.interface'
import { APIReportCategory } from '@/models/api/report-category.model'
import { ReportCategoriesServices } from '@/services/modules/report-categories.service'
import store from '@/store'
import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators'

@Module
export default class ReportCategoriesStore extends VuexModule {
    reportCategories: object[] = []
    reportcategoriesPaginate: object[] = []
    reportCategoryForm: object|null = null

    @Mutation
    updateReportCategories (newCategories: object[]) {
        this.reportCategories = newCategories
    }

    @Mutation
    updateReportCategoriesPaginate (newCategories: object[]) {
        this.reportcategoriesPaginate = newCategories
    }

    @Mutation
    updateReportCategory (newCategory: object) {
        this.reportCategoryForm = newCategory
    }

    @Action
    getReportCategories () {
        return new Promise((resolve) => {
            ReportCategoriesServices.getReportCategories()
                .then(resp => {
                    store.commit('updateReportCategories', resp.data)
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    getReportCategoriesPaginate (params: { page: number; filters?: Filter[]; limit: number; sortBy: string; sort: string }) {
        return new Promise((resolve) => {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const newParams: {[key: string]: any} = {
                page: params.page,
                limit: params.limit,
                sortBy: params.sortBy,
                sort: params.sort
            }

            if (params.filters) {
                params.filters.forEach((filter: Filter) => {
                    if (filter.queryValue) {
                        if (!newParams[filter.value]) {
                            newParams[filter.value] = filter.queryValue
                        } else {
                            let helper: string[] = []

                            if (Array.isArray(newParams[filter.value])) {
                                helper = [ ...newParams[filter.value] ]
                            } else {
                                helper.push(newParams[filter.value])
                            }

                            if (typeof filter.queryValue === 'string') helper.push(filter.queryValue)

                            newParams[filter.value] = helper
                        }
                    }
                })
            }

            ReportCategoriesServices.getReportCategoriesPaginate(newParams)
                .then(resp => {
                    store.commit('updateReportCategoriesPaginate', resp.data)
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    getReportCategoriesById (id: number) {
        return new Promise((resolve) => {
            ReportCategoriesServices.getReportCategoriesById(id)
                .then(resp => {
                    store.commit('updateReportCategory', resp.data)
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    editCategories (params: APIReportCategory) {
        params = new APIReportCategory(params)

        return new Promise((resolve) => {
            if (!(params instanceof APIReportCategory)) {
                store.commit('reportError', { code: 1000, message: 'Something went wrong :(' })
                resolve()
                return
            }

            ReportCategoriesServices.editReportCategories(params)
                .then(resp => {
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    createCategories (params: APIReportCategory) {
        params = new APIReportCategory(params)

        return new Promise((resolve) => {
            if (!(params instanceof APIReportCategory)) {
                store.commit('reportError', { code: 1000, message: 'Something went wrong :(' })
                resolve()
                return
            }

            ReportCategoriesServices.createReportCategories(params)
                .then(resp => {
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    deleteReportCategories (id: number) {
        return new Promise((resolve) => {
            ReportCategoriesServices.deleteReportCategories(id)
                .then(resp => {
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }
}
